import Big from 'big.js';

/**
 * 计算未接盈亏
 * @param side
 * @param contractSide
 * @param multiplier
 * @param qty
 * @param exitPriceEp
 * @param entryPriceEp
 * @param factor
 * @returns {number}
 */
export function calcUnrealisedPnlEv({side, contractSide, multiplier, qty, exitPriceEp, entryPriceEp, factor, priceFactor = 1e4}) {
  if (entryPriceEp === 0 || exitPriceEp === 0) {
    return 0;
  }
  const entryValue = calcValueEv(qty, multiplier, entryPriceEp, priceFactor, contractSide);
  const exitValue = calcValueEv(qty, multiplier, exitPriceEp, priceFactor, contractSide);
  if (side === 'Buy') {
    return (exitValue - entryValue) * factor * contractSide;
  }

  if (side === 'Sell') {
    return (entryValue - exitValue) * factor * contractSide;
  }

  return 0;
}

function calcValueEv(qty, multiplier, priceEp, priceFactor, contractSide) {
  if (qty === 0 || multiplier === 0 || priceEp === 0) {
    return 0;
  }
  return Number(
    Big(qty)
      .times(multiplier)
      .times(Big(priceEp / priceFactor).pow(contractSide))
      .toString()
  );
}
